<template>
  <div>
    <v-toolbar
      class="pa-3 transparent"
      dark
      flat
      >
      <a class="mt-4 t__d--n" href="/">
        <img
          width="220"
          :src="require('@/assets/logo.png')"
          lt=""
          >
      </a>

      <v-spacer></v-spacer>

      <!-- web -->
      <main-menu></main-menu>
      <!-- mobile -->
      <mobile-nav></mobile-nav>
    </v-toolbar>
  </div>
</template>

<script>
import _public from '@/router/public'
import { mapGetters } from 'vuex'

export default {
  name: 'HomeToolbar',

  computed: {
    ...mapGetters({
      mainmenu: 'mainmenu/mainmenu',
    }),
  },

  data () {
    return {
      menus: _public.children
    }
  },

  methods: {
    animateLogo (e, hide = true) {
      if (hide) {
        document.getElementById('brand').classList.add('hidden')
        document.getElementById('animated-brand').classList.remove('hidden')
      } else {
        document.getElementById('brand').classList.remove('hidden')
        document.getElementById('animated-brand').classList.add('hidden')
      }
    }
  }
}
</script>

<style>
.hidden {
  display: none;
  transition: all 0.3s ease-in;
}
</style>
